export default {
favorites_link: "FAVOURITES",
your_recomendations: "Your Recommendations",
loading_perfumes: "Loading Perfumes",
filter_by_gender: "Gender",
for_him: "For Him",
for_her: "For Her",
filter_by_family: "Family",
filter_by_brand: "Brand",
all: "All",
all_femenine: "All",
you_may_also_like: "You May Also Like",
ingredients: "Ingredients",
perfumist: "Perfumist",
description: "Description",
olfactive_family: "Olfactive Family",
expert_reviewed: "Reviewed by Experts",
main_family: "Family",
sub_family: "Subfamily",
me_family: "Fragrances of the World",
no_results: "No Results Found"
}